<template>
  <v-menu v-model="showFilterForm"
          :close-on-content-click="false"
          offset-y
          bottom
          :nudge-width="500">
    <template v-slot:activator="{on, attrs}">
      <v-btn title="Filter settings"
             text
             v-bind="attrs"
             v-on="on">
        <v-icon left>
          {{ dirty ? 'fas fa-filter' : 'fal fa-filter' }}
        </v-icon>
        {{ dirty ? 'Filtered' : 'Filter' }}
        <v-icon right>
          fas fa-caret-down
        </v-icon>
      </v-btn>
    </template>
    <v-form @submit.prevent="search"
            ref="filterForm">
      <v-card>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn icon
                 rounded
                 @click.prevent="showFilterForm = false">
            <v-icon>
              fal fa-times
            </v-icon>
          </v-btn>
        </div>
        <v-card-text class="pt-0">
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="form.name"
                            label="Name"
                            placeholder=" "
                            autocomplete="off"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="form.email"
                            label="Email"
                            placeholder=" "
                            autocomplete="off"/>
            </v-col>
          </v-row>

          <v-autocomplete v-model="form.manager_id"
                          label="Manager"
                          placeholder=" "
                          :items="activeUsers"
                          item-value="id"
                          item-text="name">
          </v-autocomplete>

          <v-row>
            <v-col cols="6">
              <v-select v-model="form.status"
                        label="Status"
                        placeholder=" "
                        :items="statuses"
                        item-value="id"
                        item-text="name">
              </v-select>
            </v-col>

            <v-col cols="6">
              <v-select v-model="form.role"
                        label="Role"
                        placeholder=" "
                        :items="roles"
                        item-value="id"
                        item-text="name">
              </v-select>
            </v-col>
          </v-row>

          <v-select v-model="form.group_id"
                    label="Group"
                    placeholder=" "
                    :items="groups"
                    item-value="id"
                    item-text="name">
          </v-select>

        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary"
                 @click.prevent="search">
            Search
          </v-btn>
          <v-btn @click.prevent="resetFilter">
            Reset
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-menu>
</template>
<script>
import {mapGetters} from 'vuex';
import dataService from '../../../../../ml/services/dataService';
import isEqual from "lodash/isEqual";

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dirty: false,
      roles: dataService.teamRoles('Any'),
      showFilterForm: false,
      statuses: dataService.userStatusCodes('Any'),
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'groups',
    ])
  },
  methods: {
    isDirty() { // @see https://github.com/cretueusebiu/vform/issues/102
      return !isEqual(this.form.data(), this.form.originalData);
    },
    resetFilter() {
      this.form.reset();
      this.$refs.filterForm.resetValidation();
      this.showFilterForm = false;
      this.dirty = false;
      this.$emit('search');
    },
    search() {
      this.dirty = this.isDirty();
      this.showFilterForm = false;
      this.$emit('search')
    },
  }
}
</script>
